import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import Edit from '@mui/icons-material/Edit';
import { useState } from 'react';
import { IconButton } from '@mui/material';
import { Delete, CheckBox, Save } from '@mui/icons-material';

export default function EmailCell(props) {
    const { email, onEdit, onDelete } = props
    const [isEditing, setIsEditing] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [hasAcc, setHasAcc] = useState(email.flags.includes("ACC"))
    const [hasRecebimentos, setHasRecebimentos] = useState(email.flags.includes("RECEBIMENTOS"))
    const [hasVendas, setHasVendas] = useState(email.flags.includes("VENDAS"))
    
    const handleEdit = () => {
        if(isEditing){
            setIsSaving(true)
            let flags = []
            if(hasAcc){
                flags.push("ACC")
            }
            if(hasRecebimentos){
                flags.push("RECEBIMENTOS")
            }
            if(hasVendas){
                flags.push("VENDAS")
            }
            const data = {
                email: email.email,
                flags: flags
            }
            onEdit(data).then((data) => {
                setIsEditing(false)
                setIsSaving(false)
            }).catch((e) => {
                setIsEditing(false)
                setIsSaving(false)
            })
        }else{
            setIsEditing(true)
        }
    }

    const handleDelete = () => {
        onDelete(email)
    }

    return (
        <TableRow
            key={email.email}
        >
            <TableCell>
            </TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal">{email.email}</TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal"><Checkbox onChange={(_, checked) => setHasAcc(checked)} defaultChecked={email.flags.includes("ACC")} disabled={!isEditing}/></TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal"><Checkbox onChange={(_, checked) => setHasVendas(checked)} defaultChecked={email.flags.includes("VENDAS")} disabled={!isEditing}/></TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal"><Checkbox onChange={(_, checked) => setHasRecebimentos(checked)} defaultChecked={email.flags.includes("RECEBIMENTOS")} disabled={!isEditing}/></TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal">
                <IconButton onClick={(event) => handleEdit()}>
                    {isEditing ? <Save color='success' fontSize='small' disabled={isSaving}/> : <Edit color="warning" fontSize='small'/>}
                </IconButton>
            </TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal">
                <IconButton onClick={(event) => handleDelete()}>
                    <Delete color="error" fontSize='small'/>
                </IconButton>
            </TableCell>
        </TableRow>
    )
}